import { Timestamp, Uid } from "./core";

export type MemberLiveBadgeKind = "job" | "place" | "pausing";

export interface MemberLiveBadge {
    uid: Uid;
    kind: MemberLiveBadgeKind;
    sinceTs?: Timestamp;
    label?: string;
    jobId?: string;
    jobNumber?: number;
    placeUid?: Uid;
}

// place badges without a label render no activity (see useMemberStatusSegments), so any
// code that suppresses or matches badges by what the row displays must use this,
// or a member ends up with no visible status at all
export function isVisibleLiveBadge(badge: MemberLiveBadge | undefined): boolean {
    return !!badge && (badge.kind !== "place" || !!badge.label);
}
